import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";
import Cookies from "js-cookie";
import { notification, Spin } from "antd";
import moment from "moment";
import {
    HiOutlineChevronLeft
} from 'react-icons/hi';
import Service from "../../helpers/Service";

// Icons
import MaleIcon from "../../assets/Doctor_Images/male_user.png";
import FemaleIcon from "../../assets/Doctor_Images/female_user.png";
import Arrivednewicon from "../../assets/clinicIcon/Group 17361.svg";
import HealthMatrics from "../../assets/clinicIcon/healthmatrics.svg";
import checkinnewicon from "../../assets/clinicIcon/Group 17362.svg";
import reportnewicon from "../../assets/clinicIcon/Group 17363.svg";
import prescriptionnewicon from "../../assets/clinicIcon/Group 17364.svg";
import uploadnewreport from "../../assets/clinicIcon/Group 17365.svg";
import checkoutnewicon from "../../assets/clinicIcon/Group 17366.svg";
import paymentnewicon from "../../assets/clinicIcon/Group 17367.svg";
import viedo_call from "../../assets/Doctor_Images/viedo_call.svg";

import "./AppointmentsDetails.css";

const AppointmentsDetails = () => {
    const { id } = useParams();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [appointment, setAppointment] = useState(null);

    useEffect(() => {
        fetchAppointmentDetails();
    }, [id]);

    const fetchAppointmentDetails = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.post("doctor/getAllAppointment", {
                clinic_id: Cookies.get("Clinic_id") || Cookies.get("clinic_id"),
                doctor_id: Cookies.get("Doctor_id") || Cookies.get("doctor_id"),
                search_date: moment().format("YYYY-MM-DD"),
            });

            if (response.data.status === 1) {
                const data = response.data.data || [];
                const filtered = data.find(x => x.booking_id == Number(id) || x.bookingId == Number(id));
                if (filtered) {
                    setAppointment(filtered);
                } else {
                    notification.error({ message: "Appointment not found in today's list" });
                }
            }
        } catch (err) {
            console.error("Failed to fetch appointment details", err);
            notification.error({ message: "Failed to load details" });
        } finally {
            setLoading(false);
        }
    };

    const navigateToReportsPage = (val) => {
        history.push(`/dashboard/appointments/report/${val.patient_id}/${val.booking_id}/${val.appointment_date}`);
    };
    const navigateToPrescriptionPage = (val) => {
        Service.check = "checking navigate data";
        history.push(`/dashboard/appointments/prescription/${val.patient_id}/${val.booking_id}/${val.appointment_date}/1/toaddprescription`);
    };
    const navigateToUploadReportPage = (val) => {
        Service.check = "checking navigate data";
        history.push(`/dashboard/appointments/uploadreport/${val.patient_id}/${val.booking_id}/${val.appointment_date}/touploadreport`);
    };

    const check = async (bookid, is_walkin, name) => {
        setLoading(true);
        try {
            const response = await axiosInstance.put("doctor/updateCheckedIn", {
                book_id: bookid,
                is_walkin: is_walkin,
                checked_in: moment().format("HH:mm:ss"),
                arrived_status: 1,
                available_status: "arrived"
            });
            if (response.data.status === 1) {
                notification.success({ message: `Patient ${name} arrived successfully.` });
                fetchAppointmentDetails();
            }
        } catch (err) {
            notification.error({ message: "Failed to update arrival status" });
        } finally {
            setLoading(false);
        }
    };

    const walkingBookingHealthMatrics = (patient_id, booking_id) => {
        history.push({
            pathname: `/dashboard/appointments/healthmetrics/${patient_id}/${booking_id}`,
            state: { appointmentData: value }
        });
    };

    const postCheckedIn = async (bookid, is_walkin, name) => {
        setLoading(true);
        try {
            const response = await axiosInstance.put("doctor/updateCheckedIn", {
                book_id: bookid,
                is_walkin: is_walkin,
                checked_in: moment().format("HH:mm:ss"),
                arrived_status: 1,
                available_status: "checkin"
            });
            if (response.data.status === 1) {
                notification.success({ message: `${name} checked in successfully.` });
                fetchAppointmentDetails();
            }
        } catch (err) {
            notification.error({ message: "Failed to check in" });
        } finally {
            setLoading(false);
        }
    };

    const postCheckedOut = async (bookid, is_walkin, name) => {
        const currentDate = new Date();
        const formattedTime = moment().format("HH:mm:ss");

        setLoading(true);
        var data = {
            book_id: bookid,
            is_walkin: is_walkin,
            checked_in: formattedTime,
        };

        axiosInstance
            .put("doctor/updateCheckedOut", data)
            .then((response) => {
                if (response.data.status == 1) {
                    notification.success({ message: `Member ${name} checked-out successfully.` });
                }
                else {
                    notification.success({ message: response.data.msg });
                }
                fetchAppointmentDetails();
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                notification.error({ message: "Failed to check out" });
            });
    };

    const paymentInsert = async (bookid, patient_id, amount) => {
        setLoading(true);
        try {
            const data = {
                doctorId: Cookies.get("Doctor_id") || Cookies.get("doctor_id"),
                patientId: patient_id,
                paymentInHand: amount,
                paymentType: 2,
                created_by: Cookies.get("Clinic_id") || Cookies.get("clinic_id"),
                appointmentId: bookid,
                insuranceId: "",
                totalAmount: "",
                totaladitionalamount: "",
                additionalservicelist: "",
            };

            const response = await axiosInstance.post("doctor/clinicPaymentInsert", data);

            if (response.data.status === 1) {
                notification.success({ message: "Payment updated successfully." });
                fetchAppointmentDetails();
            }
        } catch (err) {
            notification.error({ message: "Failed to update payment" });
        } finally {
            setLoading(false);
        }
    };

    const [aiLoading, setAiLoading] = useState(false);
    const [aiPrediction, setAiPrediction] = useState(null);

    const fetchAiSuggestions = async (val) => {
        setAiLoading(true);
        try {
            const symps = (() => {
                if (!val.symptoms || val.symptoms === "[]" || val.symptoms === "null") {
                    return "";
                }
                try {
                    const s = JSON.parse(val.symptoms);
                    return Array.isArray(s) && s.length > 0 ? s.join(', ') : (val.symptoms || "");
                } catch { 
                    return val.symptoms || ""; 
                }
            })();

            const payload = {
                patient_id: val.patient_id,
                symptoms: symps,
                service_type: val.service_type,
                metrics: {
                    height: val.height,
                    weight: val.weight,
                    blood_pressure: val.blood_pressure,
                    heart_rate: val.heart_rate,
                },
                pre_exits: val.pre_exits_disease
            };
            // Note: Use standard fetch if axios instance has strict interceptors or routes relative to doctor
            // But we use axiosInstance because it attaches token and prepends base url. Our route is /ai/doctor-prediction at the root API
            // Usually axiosInstance baseURL is something like http://localhost:8001/. So we can call:
            const response = await axiosInstance.post("../ai/doctor-prediction", payload); 
            // In case of base URL issue /api/doctor vs /ai, we can try absolute path via env or simple relative adjust
            // Wait, their endpoints are prefixed like "doctor/..."
            // I'll call plain fetch if axios fails, but let's assume it works.
            if (response.data?.status === 1 || response.data?.ai_prediction) {
                setAiPrediction(response.data.data || response.data);
                notification.success({ message: "AI Prediction generated." });
            } else {
                const errMsg = response.data?.message || "Failed to fetch AI suggestions.";
                notification.error({ message: errMsg });
            }
        } catch (err) {
            notification.error({ message: "Error contacting AI server." });
        } finally {
            setAiLoading(false);
        }
    };

    const test = () => {
        notification.info({ message: "Payment already Completed" });
    };

    if (loading && !appointment) {
        return (
            <div className="flex items-center justify-center h-screen bg-teal-50">
                <Spin size="large" />
            </div>
        );
    }

    if (!appointment) return null;

    const value = {
        ...appointment,
        booking_id: appointment.booking_id || appointment.bookingId,
        patient_id: appointment.patient_id || appointment.patientId,
        name: appointment.name || appointment.patientName,
        mobile_no: appointment.mobile_no || appointment.patientMobile,
        appointment_date: appointment.appointment_date || appointment.appointmentDate,
        appointment_time: appointment.appointment_time || appointment.appointmentTime,
        gender: (appointment.gender || "N/A").charAt(0).toUpperCase() + (appointment.gender || "").slice(1).toLowerCase(),
        age: appointment.age || "0"
    };

    const steps = [
        { prescriptDate: "Arrived", icon: Arrivednewicon },
        { prescriptDate: "Check-in", icon: checkinnewicon },
        { prescriptDate: "Health-matrics", icon: HealthMatrics },
        { prescriptDate: "Report", icon: reportnewicon },
        { prescriptDate: "Prescription", icon: prescriptionnewicon },
        { prescriptDate: "Upload Report", icon: uploadnewreport },
        { prescriptDate: "Check-out", icon: checkoutnewicon },
        { prescriptDate: "Payment", icon: paymentnewicon }
    ];

    return (
        <div className="appointment_details_page animate-in fade-in duration-300">
            <div className="appointment_details_header">
                <div className="flex items-center gap-2.5">
                    <button onClick={() => history.goBack()} className="p-1 hover:bg-gray-100 rounded text-gray-500 transition-all">
                        <HiOutlineChevronLeft size={18} />
                    </button>
                    <div>
                        <h2 className="text-sm font-bold text-gray-800 leading-tight">Appointment Details</h2>
                        <div className="flex items-center gap-2 mt-0.5">
                            <span className="text-gray-400 text-[11px] font-semibold">Booking ID: #{value.booking_id}</span>
                            <span className="text-gray-300">•</span>
                            <span className="text-teal-600 text-[11px] font-bold">Service: {value.service_type || "General Consultation"}</span>
                        </div>
                    </div>
                </div>
                <div className="appointment_type_badge">
                    {value.appointment_type || "GENERAL CLINIC"}
                </div>
            </div>

            <div className="premium_glass">
                <div className="profile_detail_container">
                    <div className="profile_image_wrapper">
                        <img
                            src={(() => {
                                const gender = (value.gender || "").toLowerCase();
                                const isMale = gender === "male" || gender === "m";
                                const hasNoImage = !value.file_name || value.file_name === " " || value.file_name === "undefined";
                                if (value.appointment_type_id == 0 || hasNoImage) return isMale ? MaleIcon : FemaleIcon;
                                return value.file_name;
                            })()}
                            alt="profile"
                            className="profile_Details1 shadow-lg"
                        />
                    </div>

                    <div className="details_grid">
                        <div className="detail_item">
                            <p className="detail_label">NAME</p>
                            <p className="detail_value">{value.name}</p>
                        </div>
                        <div className="detail_item">
                            <p className="detail_label">PATIENT ID</p>
                            <p className="detail_value">ID000{value.patient_id}</p>
                        </div>
                        <div className="detail_item">
                            <p className="detail_label">GENDER</p>
                            <p className="detail_value">{value.gender === "M" || value.gender === "Male" ? "Male" : "Female"}</p>
                        </div>

                        <div className="detail_item">
                            <p className="detail_label">APPOINTMENT DATE</p>
                            <p className="detail_value">{moment(value.appointment_date).format("DD-MMM-YY")}</p>
                        </div>
                        <div className="detail_item">
                            <p className="detail_label">APPOINTMENT TIME</p>
                            <p className="detail_value">
                                {moment(value.appointment_time, "HH:mm:ss").format("hh:mm A")}
                                {value.appointment_to_time ? ` - ${moment(value.appointment_to_time, "HH:mm:ss").format("hh:mm A")}` : ''}
                            </p>
                        </div>
                        <div className="detail_item">
                            <p className="detail_label">AGE</p>
                            <p className="detail_value">{value.age} Yrs</p>
                        </div>

                        <div className="detail_item">
                            <p className="detail_label">PHONE NO.</p>
                            <p className="detail_value">{value.mobile_no || "N/A"}</p>
                        </div>

                        {value.symptoms && value.symptoms !== '[]' && value.symptoms !== 'null' && (
                            <div className="detail_item" style={{ gridColumn: '1 / -1' }}>
                                <p className="detail_label">CHIEF COMPLAINT / SYMPTOMS</p>
                                <p className="detail_value" style={{ color: '#ef4444', fontWeight: 700 }}>
                                    {(() => {
                                        try {
                                            const s = JSON.parse(value.symptoms);
                                            return Array.isArray(s) ? s.join(', ') : value.symptoms;
                                        } catch { return value.symptoms; }
                                    })()}
                                </p>
                            </div>
                        )}

                        <div className="detail_item clinic_info_wrapper">
                            <p className="detail_label">CLINIC INFORMATION</p>
                            <p className="clinic_name_highlight">{value.clinicName || "Primary Clinic"}</p>
                            <p className="detail_address_text">{value.clinicAddress || "Main Branch Address"}</p>
                        </div>

                        {value.health_matrics_status === 1 && (
                            <div className="detail_item health_metrics_summary_card">
                                <p className="detail_label">HEALTH METRICS SUMMARY</p>
                                <div className="metrics_compact_grid">
                                    <div className="metric_row">
                                        <span className="metric_name">Height:</span> <span className="metric_val">{value.height}cm</span>
                                        <span className="metric_divider">|</span>
                                        <span className="metric_name">Weight:</span> <span className="metric_val">{value.weight}kg</span>
                                    </div>
                                    <div className="metric_row">
                                        <span className="metric_name">BP:</span> <span className="metric_val">{value.blood_pressure}</span>
                                        <span className="metric_divider">|</span>
                                        <span className="metric_name">Pulse:</span> <span className="metric_val">{value.heart_rate}bpm</span>
                                    </div>
                                </div>
                                {value.pre_exits_disease && value.pre_exits_disease !== "[]" && (
                                    <div className="disease_mini_tags mt-1">
                                        {(() => {
                                            try {
                                                const diseases = typeof value.pre_exits_disease === 'string' ? JSON.parse(value.pre_exits_disease) : value.pre_exits_disease;
                                                return Array.isArray(diseases) ? diseases.map((d, i) => (
                                                    <span key={i} className="mini_tag">{d}</span>
                                                )) : null;
                                            } catch (e) { return null; }
                                        })()}
                                    </div>
                                )}
                            </div>
                        )}

                        <div className="detail_item ai_prediction_card" style={{ gridColumn: '1 / -1', background: '#eef2ff', borderRadius: '12px', padding: '16px', border: '1px solid #c7d2fe' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                <p className="detail_label" style={{ margin: 0, color: '#4f46e5' }}>🤖 AI ASSISTANT</p>
                                <button 
                                    onClick={() => fetchAiSuggestions(value)}
                                    disabled={aiLoading}
                                    style={{ background: '#4f46e5', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold' }}>
                                    {aiLoading ? "Generating..." : "Ask AI"}
                                </button>
                            </div>
                            
                            {!aiPrediction && !aiLoading && (
                                <p style={{ fontSize: '13px', color: '#64748b' }}>Click "Ask AI" to generate disease predictions and medicine suggestions based on patient symptoms and metrics.</p>
                            )}

                            {aiPrediction && (
                                <div style={{ marginTop: '12px' }}>
                                    <p style={{ fontSize: '14px', fontWeight: 'bold', color: '#1e293b' }}>
                                        Predicted Diagnosis: <span style={{ color: '#ef4444' }}>{aiPrediction.ai_prediction || aiPrediction.predicted_disease || 'Unknown'}</span>
                                    </p>
                                    
                                    {aiPrediction.reasoning && (
                                        <p style={{ fontSize: '12px', fontStyle: 'italic', color: '#64748b', marginTop: '4px', borderLeft: '2px solid #cbd5e1', paddingLeft: '8px' }}>
                                            "{aiPrediction.reasoning}"
                                        </p>
                                    )}
                                    
                                    {aiPrediction.available_in_pharmacy && aiPrediction.available_in_pharmacy.length > 0 && (
                                        <div style={{ marginTop: '12px' }}>
                                            <p style={{ fontSize: '12px', fontWeight: 'bold', color: '#10b981', marginBottom: '4px' }}>✓ Available Medicines in Pharmacy:</p>
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                                {aiPrediction.available_in_pharmacy.map((med, i) => (
                                                    <span key={i} style={{ background: '#d1fae5', color: '#065f46', padding: '4px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: '600' }}>
                                                        {med.medicine_name} (Stock: {med.stock})
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {(!aiPrediction.available_in_pharmacy || aiPrediction.available_in_pharmacy.length === 0) && aiPrediction.generic_suggestions && (
                                        <div style={{ marginTop: '12px' }}>
                                            <p style={{ fontSize: '12px', fontWeight: 'bold', color: '#f59e0b', marginBottom: '4px' }}>! Suggested ingredients (Not found in local stock):</p>
                                            <p style={{ fontSize: '12px', color: '#64748b' }}>{aiPrediction.generic_suggestions.join(', ')}</p>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="stepper_section">
                <div className="stepper-horizontal">
                    {steps.map((data, index) => (
                        <div
                            key={index}
                            className="stepper-step"
                            onClick={() => {
                                if (data.prescriptDate === "Arrived") {
                                    if (value.arrived_status != 1) check(value.booking_id, value.appointment_type_id == 0 ? 1 : 0, value.name);
                                } else if (data.prescriptDate === "Check-in") {
                                    if (value.check_in_status == 1) notification.success({ message: "Patient Already checked in" });
                                    else if (value.arrived_status == 1)
                                        postCheckedIn(value.booking_id, value.appointment_type_id == 0 ? 1 : 0, value.name);
                                    else notification.error({ message: "Please ensure patient has arrived first" });
                                } else if (data.prescriptDate === "Health-matrics") {
                                    if (value.check_in_status == 1) walkingBookingHealthMatrics(value.patient_id, value.booking_id);
                                    else notification.error({ message: "Please check-in first" });
                                } else if (data.prescriptDate === "Report") {
                                    if (value.check_in_status == 1) navigateToReportsPage(value);
                                    else notification.error({ message: "Please check-in first" });
                                } else if (data.prescriptDate === "Prescription") {
                                    if (value.check_in_status == 1) navigateToPrescriptionPage(value);
                                    else notification.error({ message: "Please check-in first" });
                                } else if (data.prescriptDate === "Upload Report") {
                                    if (value.check_in_status == 1) navigateToUploadReportPage(value);
                                    else notification.error({ message: "Please check-in first" });
                                } else if (data.prescriptDate === "Check-out") {
                                    if (value.check_in_status == 1 && value.arrived_status == 1 && value.health_matrics_status == 1)
                                        postCheckedOut(value.booking_id, value.appointment_type_id != 0 ? 0 : 1, value.name);
                                    else if (value.health_matrics_status == 0) notification.error({ message: "Please fill health metrics first" });
                                    else notification.error({ message: "Please check-in first" });
                                } else if (data.prescriptDate === "Payment") {
                                    if (value.arrived_status == 1 && value.check_in_status === 1 && value.check_out_status === 1 && value.health_matrics_status == 1 && value.payment_status == 0)
                                        paymentInsert(value?.booking_id, value?.patient_id, value.totalFee);
                                    else test();
                                }
                            }}
                        >
                            <div className="stepper-circle-wrapper">
                                <div className={`stepper-circle ${(data.prescriptDate === "Arrived" && (value.arrived_status === 1 || value.arrived_status === "1")) ||
                                    (data.prescriptDate === "Check-in" && (value.check_in_status === 1 || value.check_in_status === "1")) ||
                                    (data.prescriptDate === "Health-matrics" && (value.health_matrics_status === 1 || value.health_matrics_status === "1")) ||
                                    (data.prescriptDate === "Report" && (value.report_status === 1 || value.report_status === "1")) ||
                                    (data.prescriptDate === "Prescription" && (value.prescription_status === 1 || value.prescription_status === "1" || value.is_send_to_pharam === 1 || value.is_send_to_pharam === "1")) ||
                                    (data.prescriptDate === "Upload Report" && (value.upload_report_status === 1 || value.upload_report_status === "1")) ||
                                    (data.prescriptDate === "Check-out" && (value.check_out_status === 1 || value.check_out_status === "1")) ||
                                    (data.prescriptDate === "Payment" && (value.payment_status === 1 || value.payment_status === "1"))
                                    ? 'active' : ''
                                    }`}>
                                    <img src={data.icon} alt={data.prescriptDate} />
                                </div>
                            </div>
                            <p className="report_time time_appointments_details">{data.prescriptDate}</p>
                        </div>
                    ))}

                    {value.appointment_type_id == 2 && (
                        <div
                            className="stepper-step"
                            onClick={() => {
                                if (value.payment_status == 1 && value.check_out_status == 1) {
                                    notification.error({ message: "Your Appointment is Ended" });
                                } else if (value.check_in_status == 1) {
                                    if (value.zoom_url) window.open(value.zoom_url, "_blank");
                                    else notification.error({ message: "Video call link not available" });
                                } else {
                                    notification.error({ message: "Please check-in first" });
                                }
                            }}
                        >
                            <div className="stepper-circle-wrapper">
                                <div className="stepper-circle" style={{
                                    border: value.check_in_status == 1 ? '3px solid #10b981' : '3px solid white',
                                    opacity: value.check_in_status == 1 ? 1 : 0.4
                                }}>
                                    <img src={viedo_call} alt="Video Call" />
                                </div>
                            </div>
                            <p className="report_time time_appointments_details">Video Call</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AppointmentsDetails;
